var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","column":"","fill-heigh":"","justify-center":""}},[_c('div',{staticClass:"action"},[_c('semipolar-spinner',{attrs:{"animation-duration":2000,"size":115,"color":"#1935ff"}})],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }